<template>
  <v-snackbar :timeout="value.timeout" top :value="true"
              @input="remove(value)" :color="value.color" :style="style" :key="value.id">
    {{ value.message }}
    <v-btn v-if="value.bugReport" flat icon @click="openBugReport">
      <v-icon>bug_report</v-icon>
    </v-btn>
    <v-btn flat @click="remove(value)">Close</v-btn>
  </v-snackbar>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    props: ['value', 'offset'],
    computed: {
      style() {
        return { top: `${this.offset}px` };
      }
    },
    methods: {
      openBugReport() {
      },
      ...mapActions('alert', [
        'remove'
      ])
    }
  };
</script>

<style>
  .error-embed .powered-by {
    display: none;
  }
</style>
